const Testimonials = () => {
  const testimonial = {
    id: 1,
    quote: '「少人数・高密度」が生み出す、唯一無二の熱量。私たちは、大人数の画一的なイベントではなく、30名〜70名程度の「互いの息遣いが聞こえる規模」でのプロデュースを最も得意としています。一人ひとりのゲストに「私だけが特別である」という優越感と深い充足感をお持ち帰りいただくこと。そのために、場所の選定から、光の角度、音の余韻、そしてスタッフの視線ひとつに至るまで、徹底した美意識でコントロールします。貴社の大切な顧客、そしてブランドの未来を託すにふさわしい、「量より質の極致」を形にすることが、私たちの使命です。',
  };

  return (
    <section id="mission" className="relative py-16 lg:py-32 overflow-hidden" style={{ backgroundColor: '#FAF7F2' }}>
      {/* 背景ロゴ画像 */}
      <div
        className="absolute inset-0 flex items-start pointer-events-none justify-end lg:justify-end"
        style={{ opacity: 0.18, paddingTop: 'clamp(400px, 60vw, 380px)', paddingRight: '3%' }}
      >
        <img
          src="https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/b0acfccb76e584cf6694c81048c7ba06.png"
          alt=""
          className="lg:w-[58%]"
          style={{
            width: '80%',
            maxWidth: '740px',
            objectFit: 'contain',
            mixBlendMode: 'multiply',
            marginRight: '-10%',
            marginLeft: 'auto',
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          {/* 右側：テキストコンテンツ */}
          <div>
            {/* セクションヘッダー */}
            <div className="mb-8 lg:mb-12">
              <div className="flex items-center space-x-4 mb-2">
                <div className="w-8 h-px bg-black"></div>
                <span className="text-2xl md:text-5xl tracking-[0.3em] text-gray-600 uppercase" style={{ fontWeight: 900 }}>MISSION</span>
              </div>
              <div className="pl-12 mb-6 lg:mb-8">
                <h2 className="font-extralight text-black tracking-tight" style={{ fontSize: 'clamp(0.85rem, 1.8vw, 1.1rem)' }}>
                  使命
                </h2>
              </div>
              <h2
                className="text-black tracking-tight"
                style={{
                  fontSize: 'clamp(1.3rem, 4.5vw, 2.5rem)',
                  fontFamily: '"Noto Serif JP", "Yu Mincho", "YuMincho", "Hiragino Mincho ProN", Georgia, serif',
                  letterSpacing: '0.06em',
                  fontWeight: 700,
                  color: 'rgb(200, 16, 46)',
                  fontStyle: 'normal',
                }}
              >
                Why
                <br />
                BYTWOTEMPOS?
              </h2>
            </div>

            {/* テスティモニアル */}
            <div>
              <blockquote className="mb-8 lg:mb-12">
                <p className="font-light text-gray-800 leading-relaxed" style={{ fontSize: 'clamp(0.88rem, 2.5vw, 1.05rem)' }}>
                  {testimonial.quote}
                </p>
              </blockquote>
              <div className="w-8 h-px bg-gray-300"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
